import { BloodPressureValue } from "../model/challenge/BloodPressureValue";

export const formatBloodPressure = (data?: BloodPressureValue): string => {
  return data ? `${data.systolic}/${data.diastolic} mmHg` : "-";
};
